import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-property-fp-dialog',
  templateUrl: 'property-fp-dialog.component.html',
  styleUrls: ['./property-fp-dialog.component.scss']
})

export class PropertyFpDialogComponent implements OnInit{

  SERVER_URL = environment.SERVER_URL;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {

  }

  ngOnInit(): void {
    console.log(this.data, this.data.floorPlan, this.data.unitNumber);
  }
}
